/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Picker_ClearInputs */

const cs_entity_picker_clear = /** @type {(inputs: Entity_Picker_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit výběr`)
};

const en_entity_picker_clear = /** @type {(inputs: Entity_Picker_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Entity_Picker_ClearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_picker_clear = /** @type {((inputs?: Entity_Picker_ClearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Picker_ClearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_picker_clear(inputs)
	return cs_entity_picker_clear(inputs)
});